import { history } from "../../../shared/history/history";
import { Component } from "react";
import React from "react";
import "./backStyle.scss";

class BackComponent extends Component {
  goBack() {
    history.goBack();
  }

  render() {
    const { triggerAnimation } = this.props;
    return (
      <div onClick={() => this.goBack()} className="back">
        <img alt="Back" src={require("../../../public/static/back.svg")}></img>
        <span className={"back__text"}>Back</span>
      </div>
    );
  }
}

export default BackComponent;
